import { Alert, Spin, theme } from 'antd'
import type { ReactNode } from 'react'
import { useMemo } from 'react'

export function useChartTheme() {
  const { token } = theme.useToken()
  return useMemo(
    () => ({
      axis: {
        x: { labelAutoRotate: false, labelFill: token.colorTextSecondary },
        y: { labelFill: token.colorTextSecondary },
      },
      legend: {
        color: { itemLabelFill: token.colorText },
      },
    }),
    [token.colorText, token.colorTextSecondary],
  )
}

export function ChartSpin() {
  return (
    <div
      style={{
        height: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Spin />
    </div>
  )
}

export function ChartBody<T>({
  data,
  loading,
  errorMessage,
  children,
}: {
  data: T | undefined
  loading: boolean
  errorMessage: string
  children: (data: T) => ReactNode
}) {
  if (data) return <>{children(data)}</>
  if (loading) return <ChartSpin />
  return <Alert type="error" showIcon message={errorMessage} />
}
